/**
 * Facets: mobile panel toggle + backdrop
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function initFacetDrawer() {
    var drawer = qs('[data-nw-facet-drawer]');
    var openBtn = qs('[data-nw-filter-toggle]');
    var closeBtn = qs('[data-nw-facet-close]');
    var backdrop = qs('[data-nw-facet-backdrop]');
    if (!drawer || !openBtn) return;

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function set(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (backdrop) {
        backdrop.classList.toggle('is-open', open);
        backdrop.style.pointerEvents = open ? 'auto' : 'none';
        backdrop.style.opacity = open ? '1' : '0';
      }
      document.body.style.overflow = open && isMobile() ? 'hidden' : '';
    }

    openBtn.addEventListener('click', function () {
      set(!drawer.classList.contains('is-open'));
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        set(false);
      });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        set(false);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) set(false);
    });
    window.addEventListener('resize', function () {
      if (!isMobile()) set(false);
    });
  }

  document.addEventListener('DOMContentLoaded', initFacetDrawer);
})();
